module.exports = __webpack_public_path__ + "img/fence_checked.108bd80e.png";